import React, { useMemo } from "react";
import { Helmet } from "react-helmet";

function isHTMLContent(data) {
  const htmlRegex = /<[a-z][\s\S]*>/i;
  return htmlRegex.test(data);
}

const ProductSchema = (props) => {
  const { product, productSchemaData } = props;

  if (!product) {
    return null;
  }
  const currentUrl = window.location.href;

  let encodedDescription = "";

  let afterDiscount = 0;

  if (product.__typename === "BundleProduct") {
    afterDiscount = product?.items[0]?.options?.reduce((acc, curr) => {
      return (
        acc +
        curr.product.price_range.maximum_price.final_price.value * curr.quantity
      );
    }, 0);
  }

  if (product.short_description.html) {
    if (isHTMLContent(product.short_description.html)) {
      encodedDescription = encodeURIComponent(product.short_description.html);
    } else {
      encodedDescription = product.short_description.html;
    }
  }

  const productSchema = useMemo(() => {
    const productSchemaContent = {
      name: productSchemaData?.name,
      image: product.small_image.url,
      description: encodedDescription,
      brand: {
        name: productSchemaData?.name,
      },
      sku: product.sku,
      offers: {
        url: currentUrl,
        priceCurrency: product.price_range.minimum_price.final_price.currency,
        price:
          product.__typename === "BundleProduct"
            ? afterDiscount
            : product.price_range.minimum_price.final_price.value,
      },
    };
    return productSchemaContent;
  }, [product, currentUrl, encodedDescription]);

  const content = `{
        "@context": "https://schema.org/", 
        "@type": "Product", 
        "name": "${productSchema.name}",
        "image": "${productSchema.image}",
        "description": "${productSchema.description}",
        "brand": {
          "@type": "Brand",
          "name": "${productSchema.brand.name}"
        },
        "sku": "MP12",
        "offers": {
          "@type": "Offer",
          "url": "${productSchema.offers.url}",
          "priceCurrency": "${productSchema.offers.priceCurrency}",
          "price": "${productSchema.offers.price}"
        }
    }`;

  return (
    <Helmet>
      <script type="application/ld+json">{content}</script>;
    </Helmet>
  );
};

export default ProductSchema;
